import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.less',
})
export class LoaderComponent {
  @Input() isLoading: boolean = false;
  @Input() loadingStatus: 'loading' | 'success' | 'error' = 'loading';
}
